import {
    CHANGE_VOUCHER_TABLE_DATA,
    CHANGE_VOUCHER_CODE,
    REQUEST_VOUCHER_TABLE_DATA,
    ERROR_VOUCHER_TABLE_DATA
} from './type'
import * as selector from "./selector";
import {post} from "../../../../util/api";

export const onVoucherCodeChange = (name, value) => ({
    type: CHANGE_VOUCHER_CODE,
    payload: {
        name,
        value,
    },
})

export const onVoucherCodeEnter = () => (dispatch, getState) => {
    const state = getState()
    const voucherCode = selector.selectVoucherCode(state)

    dispatch({
        type: REQUEST_VOUCHER_TABLE_DATA
    })

    post('/api/voucher/find-voucher-by-code', {'voucherCode': voucherCode.value})
        .then(objectList => {
            dispatch({
                type: CHANGE_VOUCHER_TABLE_DATA,
                payload: {
                    objectList,
                },
            })
        })
        .catch(error => {
            alert('an error occured, please try later');
            dispatch({
                type: ERROR_VOUCHER_TABLE_DATA,
                payload: {
                    error
                },
            })
        })
}



// WEBPACK FOOTER //
// ./src/modules/voucher/state/search/action.js